import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { ErrorBoundary } from './components/ErrorBoundary'
import { I18nProvider } from './i18n/context'
import { AuthProvider } from './auth/AuthContext'
import { AuthGate } from './auth/AuthGate'
import './styles.css'

const CANONICAL_HOST = 'investalbum.com.br'

if (window.location.protocol.startsWith('http')) {
  const host = window.location.hostname.toLowerCase()
  if (host.endsWith('netlify.app') && host !== CANONICAL_HOST) {
    const nextUrl = `https://${CANONICAL_HOST}${window.location.pathname}${window.location.search}${window.location.hash}`
    window.location.replace(nextUrl)
  }
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <I18nProvider>
      <AuthProvider>
        <ErrorBoundary>
          <AuthGate>
            <App />
          </AuthGate>
        </ErrorBoundary>
      </AuthProvider>
    </I18nProvider>
  </React.StrictMode>
)
